export function validateNorwegianOrganisationNumber(params: string[]) {
  return `${params[0]}`.length === 9;
}
